import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { sendTicket } from "../../redux/slice/tickets";
import { sendInvoice } from "../../redux/slice/invoice";
import { sendOrder, sendReminderOrder } from "../../redux/slice/orders";
import { setResendModalParams, setErrorMessage } from "../../redux/slice/const";
import toast from "react-hot-toast";
import {
  errorResendEmail,
  successOrderEmail,
} from "./../../utility/ModalHelper";
import {
  Input,
  Modal,
  Button,
  Spinner,
  ModalBody,
  FormGroup,
  ModalHeader,
  ModalFooter,
} from "reactstrap";

export default function ResendModal() {
  const { resendModalParams, errorMessage } = useSelector(
    (state) => state.globalConst
  );
  const [switchEmail, setSwitchEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [valid, setValid] = useState(false);
  const er = new RegExp("^[^@]+@[^@]+.[a-zA-Z]{2,}$");
  const dispatch = useDispatch();
  let args = {};
  let header = "";
  let body = "";
  let call = "";

  const toggleModal = () => {
    setSwitchEmail(false);
    dispatch(
      setResendModalParams({ show: false, email: "", view: "", id: "" })
    );
  };

  if (resendModalParams?.show) {
    if (resendModalParams?.view === "ticket") {
      const data = {
        type: "email",
        email:
          resendModalParams?.email && newEmail === ""
            ? resendModalParams?.email
            : newEmail,
      };

      const auxArgs = {
        ticketId: resendModalParams?.id,
        eventId: resendModalParams?.eventId,
        data,
      };
      args = auxArgs;
      call = sendTicket;
      header = "Reenviar Boleto";
      body = "Enviar boleto al correo: ";
    } else if (resendModalParams?.view === "order") {
      const auxArgs = {
        id: resendModalParams?.id,
        eventId: resendModalParams?.eventId,
        email:
          resendModalParams?.email && newEmail === ""
            ? resendModalParams?.email
            : newEmail,
      };
      args = auxArgs;
      call = sendOrder;
      header = "Reenviar Orden";
      body = "Enviar orden al correo: ";
    } else if (resendModalParams?.view === "orderRemind") {
      const auxArgs = {
        id: resendModalParams?.id,
        eventId: resendModalParams?.eventId,
        email:
          resendModalParams?.email && newEmail === ""
            ? resendModalParams?.email
            : newEmail,
      };

      args = auxArgs;
      call = sendReminderOrder;
      header = "Enviar Recordatorio de pago";
      body = "Enviar recordatorio al correo: ";
    } else if (resendModalParams?.view === "sendInvoice") {
      const auxArgs = {
        invoiceId: resendModalParams?.invoiceId,
        eventId: resendModalParams?.eventId,
        email:
          resendModalParams?.email && newEmail === ""
            ? resendModalParams?.email
            : newEmail,
      };
      args = auxArgs;
      call = sendInvoice;
      header = "Enviar factura";
      body = "Enviar factura al correo: ";
    }
  }

  const handleTicketResent = () => {
    if (resendModalParams?.email && newEmail === "") {
      dispatch(call(args))
        .unwrap()
        .then(() => {
          toggleModal();
          successOrderEmail(resendModalParams?.email);
          setLoading(false);
        })
        .catch((error) => {
          toggleModal();
          errorResendEmail(resendModalParams?.email);
          setLoading(false);
          {
            errorMessage !== ""
              ? toast.error(`${errorMessage}, inténtelo de nuevo más tarde.`, {
                  autoClose: 2000,
                })
              : toast.error(`Algo salió mal, inténtelo de nuevo más tarde.`, {
                  autoClose: 2000,
                });
          }
          dispatch(setErrorMessage(""));
        });
      setValid(false);
    } else {
      if (newEmail.match(er) !== null) {
        dispatch(call(args))
          .unwrap()
          .then(() => {
            toggleModal();
            successOrderEmail(newEmail);
            setLoading(false);
          })
          .catch((error) => {
            toggleModal();
            errorResendEmail(newEmail);
            setLoading(false);
            {
              errorMessage !== ""
                ? toast.error(
                    `${errorMessage}, inténtelo de nuevo más tarde.`,
                    {
                      autoClose: 2000,
                    }
                  )
                : toast.error(`Algo salió mal, inténtelo de nuevo más tarde.`, {
                    autoClose: 2000,
                  });
            }
            dispatch(setErrorMessage(""));
          });
        setValid(false);
        setNewEmail("");
      } else {
        setValid(true);
      }
    }
  };

  return (
    <Modal
      toggle={() => toggleModal()}
      isOpen={resendModalParams?.show}
      className="modal-dialog-centered"
    >
      <ModalHeader className="bg-white" toggle={() => toggleModal()}>
        <strong>{header}</strong>
      </ModalHeader>
      <ModalBody className="bg-white">
        {!switchEmail ? (
          <span className="font-weight-bold">
            {" "}
            <strong>{body}</strong>
            {resendModalParams?.email}
          </span>
        ) : (
          <FormGroup>
            <span>Ingresa el correo.</span>
            <Input
              type="email"
              placeholder="Correo electrónico"
              className={`${valid ? "is-invalid" : ""}`}
              onChange={(e) => setNewEmail(e.target.value)}
            />
            {valid ? (
              <div className="invalid-feedback">Correo invalido.</div>
            ) : (
              <></>
            )}
          </FormGroup>
        )}
      </ModalBody>
      <ModalFooter className="bg-white">
        <Button
          size="sm"
          disabled={loading}
          color="flat-secondary"
          onClick={() => {
            setSwitchEmail(!switchEmail);
            setNewEmail("");
          }}
        >
          {!switchEmail ? <span>Cambiar correo</span> : <span>Cancelar</span>}
        </Button>
        <Button
          size="sm"
          color="primary"
          disabled={loading}
          onClick={() => {
            setLoading(true);
            handleTicketResent();
          }}
        >
          {loading ? (
            <span>
              Enviando...
              <Spinner className="ms-1" size="sm" />
            </span>
          ) : (
            <span className="align-middle ml-25">Reenviar</span>
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
